import React, { useState } from 'react';
import {
    TextField,
    Button,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import {
    Close as CloseIcon
} from '@mui/icons-material';
import {notification} from "antd";
import {isValidAdTagDomain} from "@/utils/validateDomain";

// Попап для добавления домена
const DomainPopup = ({ open, onClose, onAdd }) => {
    const [domainName, setDomainName] = useState('');

    const handleSubmit = () => {
        const raw = domainName.trim();

        if (!isValidAdTagDomain(raw)) {
            notification.warning({
                message: `Пожалуйста, введите корректный домен: "${domainName}"\nПример: example.com, пример.рф или https://example.com`,
            });
            return;
        }

        if (raw) {
            // Сервер сохранит punycode, в таблице покажется U-label.
            onAdd(raw);
            setDomainName('');
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                Добавить домен
                <IconButton
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Название домена"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={domainName}
                    onChange={(e) => setDomainName(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                    helperText="Можно вводить кириллицу: сохраняется punycode, отображается Unicode."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Отмена</Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={!domainName.trim()}
                >
                    Добавить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DomainPopup;